// src/pages/MasrafTalepPage.js
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const KATEGORILER = ['Ulaşım', 'Konaklama', 'Yemek', 'Temsil', 'Ofis Malzemesi', 'Eğitim', 'Diğer'];

const durumRenk = {
  taslak: '#6B7280', onay_sureci: '#D97706', onaylandi: '#059669', reddedildi: '#DC2626'
};
const durumEtiket = {
  taslak: 'Taslak', onay_sureci: 'Onay Sürecinde', onaylandi: 'Onaylandı', reddedildi: 'Reddedildi'
};

const fmt = (t) => t ? new Date(t).toLocaleDateString('tr-TR') : '-';
const paraBirim = (t, pb) => t ? Number(t).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' ' + (pb || 'TRY') : '-';

export default function MasrafTalepPage({ yonetim = false }) {
  const [talepler, setTalepler] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [seciliTalep, setSeciliTalep] = useState(null);
  const [detay, setDetay] = useState(null);
  const [detayYukleniyor, setDetayYukleniyor] = useState(false);
  const [yeniModalAcik, setYeniModalAcik] = useState(false);
  const [kalemModalAcik, setKalemModalAcik] = useState(false);
  const [filtre, setFiltre] = useState('hepsi');
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');

  const [yeniForm, setYeniForm] = useState({ baslik: '', aciklama: '', para_birimi: 'TRY' });
  const [kalemForm, setKalemForm] = useState({ kategori: '', aciklama: '', tutar: '', tarih: '', fis: null });

  const getir = useCallback(async () => {
    try {
      setYukleniyor(true);
      const url = yonetim ? '/api/masraf/hepsi' : '/api/masraf/benim';
      const r = await axios.get(url);
      setTalepler(r.data);
    } catch { setHata('Veriler yüklenemedi'); }
    finally { setYukleniyor(false); }
  }, [yonetim]);

  useEffect(() => { getir(); }, [getir]);

  const detayGetir = async (id) => {
    try {
      setDetayYukleniyor(true);
      const r = await axios.get(`/api/masraf/${id}`);
      setDetay(r.data);
      setSeciliTalep(id);
    } catch { }
    finally { setDetayYukleniyor(false); }
  };

  const yeniOlustur = async () => {
    if (!yeniForm.baslik) { setHata('Başlık zorunludur'); return; }
    try {
      const r = await axios.post('/api/masraf', yeniForm);
      setYeniModalAcik(false);
      setYeniForm({ baslik: '', aciklama: '', para_birimi: 'TRY' });
      await getir();
      await detayGetir(r.data.id);
      setBasari('Masraf talebi oluşturuldu');
      setTimeout(() => setBasari(''), 3000);
    } catch (err) { setHata(err.response?.data?.hata || 'Hata oluştu'); }
  };

  const kalemEkle = async () => {
    if (!kalemForm.kategori || !kalemForm.aciklama || !kalemForm.tutar || !kalemForm.tarih) {
      setHata('Tüm alanları doldurun'); return;
    }
    try {
      const fd = new FormData();
      fd.append('kategori', kalemForm.kategori);
      fd.append('aciklama', kalemForm.aciklama);
      fd.append('tutar', kalemForm.tutar);
      fd.append('tarih', kalemForm.tarih);
      if (kalemForm.fis) fd.append('fis', kalemForm.fis);

      await axios.post(`/api/masraf/${seciliTalep}/kalem`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setKalemModalAcik(false);
      setKalemForm({ kategori: '', aciklama: '', tutar: '', tarih: '', fis: null });
      await detayGetir(seciliTalep);
      setHata('');
    } catch (err) { setHata(err.response?.data?.hata || 'Hata oluştu'); }
  };

  const kalemSil = async (kalemId) => {
    if (!window.confirm('Bu kalemi silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`/api/masraf/${seciliTalep}/kalem/${kalemId}`);
      await detayGetir(seciliTalep);
    } catch (err) { setHata(err.response?.data?.hata || 'Hata'); }
  };

  const onayaGonder = async () => {
    if (!window.confirm('Talebi onaya göndermek istediğinize emin misiniz?')) return;
    try {
      await axios.post(`/api/masraf/${seciliTalep}/gonder`);
      setBasari('Talep onaya gönderildi');
      await getir();
      await detayGetir(seciliTalep);
      setTimeout(() => setBasari(''), 3000);
    } catch (err) { setHata(err.response?.data?.hata || 'Hata'); }
  };

  const talepSil = async (id) => {
    if (!window.confirm('Bu talebi silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`/api/masraf/${id}`);
      setSeciliTalep(null);
      setDetay(null);
      await getir();
    } catch (err) { setHata(err.response?.data?.hata || 'Hata'); }
  };

  const filtrelenmis = talepler.filter(t => filtre === 'hepsi' ? true : t.durum === filtre);

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
          <h1 style={{ fontSize: '24px', fontWeight: 700, color: '#111827', margin: 0 }}>
            💸 {yonetim ? 'Masraf Yönetimi' : 'Masraf Taleplerim'}
          </h1>
          <p style={{ color: '#6B7280', marginTop: '4px', fontSize: '14px' }}>{talepler.length} talep</p>
        </div>
        {!yonetim && (
          <button onClick={() => { setYeniModalAcik(true); setHata(''); }} style={{ background: '#4F46E5', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: 600 }}>
            + Yeni Talep
          </button>
        )}
      </div>

      {hata && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>⚠️ {hata}</div>}
      {basari && <div style={{ background: '#F0FDF4', color: '#16A34A', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>✅ {basari}</div>}

      {/* Filtre */}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
        {[['hepsi','Hepsi'],['taslak','Taslak'],['onay_sureci','Onay Sürecinde'],['onaylandi','Onaylandı'],['reddedildi','Reddedildi']].map(([k,l]) => (
          <button key={k} onClick={() => setFiltre(k)} style={{
            padding: '6px 14px', borderRadius: '6px', border: '1.5px solid',
            borderColor: filtre === k ? '#4F46E5' : '#E5E7EB',
            background: filtre === k ? '#EEF2FF' : '#fff',
            color: filtre === k ? '#4F46E5' : '#6B7280',
            cursor: 'pointer', fontWeight: filtre === k ? 700 : 400, fontSize: '13px'
          }}>{l}</button>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: seciliTalep ? '1fr 1.5fr' : '1fr', gap: '20px' }}>
        {/* Sol: Liste */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {yukleniyor ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#9CA3AF' }}>Yükleniyor...</div>
          ) : filtrelenmis.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', background: '#F9FAFB', borderRadius: '12px', border: '2px dashed #E5E7EB' }}>
              <div style={{ fontSize: '40px', marginBottom: '8px' }}>💸</div>
              <p style={{ color: '#6B7280' }}>Talep bulunamadı</p>
            </div>
          ) : filtrelenmis.map(t => (
            <div key={t.id} onClick={() => detayGetir(t.id)} style={{
              background: '#fff', border: `1.5px solid ${seciliTalep === t.id ? '#4F46E5' : '#E5E7EB'}`,
              borderRadius: '10px', padding: '14px 16px', cursor: 'pointer',
              boxShadow: seciliTalep === t.id ? '0 0 0 3px #EEF2FF' : '0 1px 3px rgba(0,0,0,0.05)',
              transition: 'all 0.15s'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: '14px', color: '#111827' }}>{t.baslik}</div>
                  {yonetim && <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '2px' }}>{t.personel_ad}</div>}
                  <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '4px' }}>
                    {t.kalem_sayisi} kalem · {fmt(t.olusturma_tarihi)}
                  </div>
                </div>
                <div style={{ textAlign: 'right', flexShrink: 0, marginLeft: '12px' }}>
                  <div style={{ fontWeight: 700, fontSize: '15px', color: '#111827' }}>
                    {paraBirim(t.toplam_tutar, t.para_birimi)}
                  </div>
                  <span style={{
                    background: durumRenk[t.durum] + '15', color: durumRenk[t.durum],
                    fontSize: '11px', padding: '2px 8px', borderRadius: '4px', fontWeight: 700
                  }}>{durumEtiket[t.durum]}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Sağ: Detay */}
        {seciliTalep && (
          <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', overflow: 'hidden' }}>
            {detayYukleniyor ? (
              <div style={{ textAlign: 'center', padding: '40px', color: '#9CA3AF' }}>Yükleniyor...</div>
            ) : detay ? (
              <>
                {/* Başlık */}
                <div style={{ padding: '16px 20px', borderBottom: '1px solid #F3F4F6', background: '#FAFAFA', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <h3 style={{ fontWeight: 700, fontSize: '16px', margin: 0 }}>{detay.baslik}</h3>
                    <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px' }}>{detay.personel_ad} · {fmt(detay.olusturma_tarihi)}</div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <span style={{ background: durumRenk[detay.durum] + '15', color: durumRenk[detay.durum], fontSize: '12px', padding: '4px 10px', borderRadius: '6px', fontWeight: 700 }}>
                      {durumEtiket[detay.durum]}
                    </span>
                    <button onClick={() => { setSeciliTalep(null); setDetay(null); }} style={{ background: '#F3F4F6', border: 'none', borderRadius: '6px', width: '28px', height: '28px', cursor: 'pointer', fontSize: '14px' }}>✕</button>
                  </div>
                </div>

                {/* Onay süreci */}
                {detay.onaylar && detay.onaylar.length > 0 && (
                  <div style={{ padding: '14px 20px', borderBottom: '1px solid #F3F4F6', display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                    {detay.onaylar.map((o, idx) => (
                      <React.Fragment key={o.id}>
                        <div style={{
                          background: o.durum === 'onaylandi' ? '#F0FDF4' : o.durum === 'reddedildi' ? '#FEF2F2' : '#F9FAFB',
                          border: `1px solid ${o.durum === 'onaylandi' ? '#86EFAC' : o.durum === 'reddedildi' ? '#FCA5A5' : '#E5E7EB'}`,
                          borderRadius: '8px', padding: '8px 12px', minWidth: '120px'
                        }}>
                          <div style={{ fontSize: '10px', fontWeight: 700, color: '#9CA3AF', textTransform: 'uppercase' }}>Adım {o.sira}</div>
                          <div style={{ fontSize: '13px', fontWeight: 600, color: '#111827' }}>{o.adim_baslik}</div>
                          <div style={{ fontSize: '11px', color: o.durum === 'onaylandi' ? '#059669' : o.durum === 'reddedildi' ? '#DC2626' : '#9CA3AF', marginTop: '2px' }}>
                            {o.durum === 'onaylandi' ? `✓ ${o.onaylayan_ad}` : o.durum === 'reddedildi' ? `✗ ${o.onaylayan_ad}` : '⏳ Bekliyor'}
                          </div>
                        </div>
                        {idx < detay.onaylar.length - 1 && <span style={{ color: '#D1D5DB' }}>→</span>}
                      </React.Fragment>
                    ))}
                  </div>
                )}

                {/* Kalemler */}
                <div style={{ padding: '16px 20px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                    <span style={{ fontWeight: 700, fontSize: '14px', color: '#374151' }}>Masraf Kalemleri</span>
                    {detay.durum === 'taslak' && !yonetim && (
                      <button onClick={() => { setKalemModalAcik(true); setHata(''); setKalemForm({ kategori: '', aciklama: '', tutar: '', tarih: new Date().toISOString().slice(0,10), fis: null }); }}
                        style={{ background: '#EEF2FF', color: '#4F46E5', border: 'none', padding: '6px 14px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' }}>
                        + Kalem Ekle
                      </button>
                    )}
                  </div>

                  {(!detay.kalemler || detay.kalemler.length === 0) ? (
                    <div style={{ textAlign: 'center', padding: '24px', background: '#F9FAFB', borderRadius: '8px', color: '#9CA3AF', fontSize: '13px' }}>
                      Henüz kalem eklenmemiş
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
                      {detay.kalemler.map(k => (
                        <div key={k.id} style={{ background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <div style={{ background: '#EEF2FF', color: '#4F46E5', fontSize: '11px', padding: '3px 8px', borderRadius: '4px', fontWeight: 600, flexShrink: 0 }}>{k.kategori}</div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: '13px', fontWeight: 600, color: '#111827' }}>{k.aciklama}</div>
                            <div style={{ fontSize: '11px', color: '#9CA3AF' }}>{fmt(k.tarih)}</div>
                          </div>
                          <div style={{ fontWeight: 700, fontSize: '14px', color: '#111827', flexShrink: 0 }}>{paraBirim(k.tutar, k.para_birimi)}</div>
                          {k.fis_adi && <span style={{ fontSize: '11px', color: '#059669' }}>📎</span>}
                          {detay.durum === 'taslak' && !yonetim && (
                            <button onClick={() => kalemSil(k.id)} style={{ background: '#FEF2F2', color: '#DC2626', border: 'none', padding: '4px 10px', borderRadius: '5px', cursor: 'pointer', fontSize: '12px' }}>Sil</button>
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Toplam */}
                  <div style={{ borderTop: '1.5px solid #E5E7EB', paddingTop: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: 700, fontSize: '15px', color: '#374151' }}>Toplam</span>
                    <span style={{ fontWeight: 700, fontSize: '18px', color: '#4F46E5' }}>{paraBirim(detay.toplam_tutar, detay.para_birimi)}</span>
                  </div>

                  {/* Aksiyonlar */}
                  {!yonetim && (
                    <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
                      {detay.durum === 'taslak' && (
                        <>
                          <button onClick={onayaGonder} disabled={!detay.kalemler || detay.kalemler.length === 0}
                            style={{ flex: 2, padding: '10px', background: '#4F46E5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, opacity: (!detay.kalemler || detay.kalemler.length === 0) ? 0.5 : 1 }}>
                            Onaya Gönder
                          </button>
                          <button onClick={() => talepSil(detay.id)}
                            style={{ flex: 1, padding: '10px', background: '#FEF2F2', color: '#DC2626', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600 }}>
                            Sil
                          </button>
                        </>
                      )}
                      {detay.durum === 'reddedildi' && (
                        <button onClick={() => talepSil(detay.id)}
                          style={{ padding: '10px 20px', background: '#FEF2F2', color: '#DC2626', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600 }}>
                          Talebi Sil
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </>
            ) : null}
          </div>
        )}
      </div>

      {/* Yeni Talep Modal */}
      {yeniModalAcik && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '440px', boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}>
            <h2 style={{ fontSize: '20px', fontWeight: 700, margin: '0 0 20px' }}>+ Yeni Masraf Talebi</h2>
            {hata && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '10px', borderRadius: '8px', marginBottom: '14px', fontSize: '14px' }}>⚠️ {hata}</div>}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Başlık *</label>
                <input value={yeniForm.baslik} onChange={e => setYeniForm(f => ({ ...f, baslik: e.target.value }))}
                  placeholder="örn: Kasım Ayı Seyahat Masrafları"
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Açıklama</label>
                <textarea value={yeniForm.aciklama} onChange={e => setYeniForm(f => ({ ...f, aciklama: e.target.value }))} rows={3}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', resize: 'vertical', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Para Birimi</label>
                <select value={yeniForm.para_birimi} onChange={e => setYeniForm(f => ({ ...f, para_birimi: e.target.value }))}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                  <option value="TRY">TRY — Türk Lirası</option>
                  <option value="USD">USD — Amerikan Doları</option>
                  <option value="EUR">EUR — Euro</option>
                  <option value="GBP">GBP — İngiliz Sterlini</option>
                </select>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
              <button onClick={() => setYeniModalAcik(false)} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1.5px solid #E5E7EB', background: '#fff', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
              <button onClick={yeniOlustur} style={{ flex: 2, padding: '10px', borderRadius: '8px', border: 'none', background: '#4F46E5', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>Oluştur</button>
            </div>
          </div>
        </div>
      )}

      {/* Kalem Modal */}
      {kalemModalAcik && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '480px', boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}>
            <h2 style={{ fontSize: '20px', fontWeight: 700, margin: '0 0 20px' }}>+ Masraf Kalemi Ekle</h2>
            {hata && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '10px', borderRadius: '8px', marginBottom: '14px', fontSize: '14px' }}>⚠️ {hata}</div>}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Kategori *</label>
                <select value={kalemForm.kategori} onChange={e => setKalemForm(f => ({ ...f, kategori: e.target.value }))}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                  <option value="">— Seçin —</option>
                  {KATEGORILER.map(k => <option key={k} value={k}>{k}</option>)}
                </select>
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Açıklama *</label>
                <input value={kalemForm.aciklama} onChange={e => setKalemForm(f => ({ ...f, aciklama: e.target.value }))}
                  placeholder="örn: İstanbul-Ankara uçak bileti"
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Tutar *</label>
                  <input type="number" value={kalemForm.tutar} onChange={e => setKalemForm(f => ({ ...f, tutar: e.target.value }))}
                    placeholder="0.00"
                    style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
                </div>
                <div>
                  <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Tarih *</label>
                  <input type="date" value={kalemForm.tarih} onChange={e => setKalemForm(f => ({ ...f, tarih: e.target.value }))}
                    style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
                </div>
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Fiş/Fatura (PDF, JPG, PNG)</label>
                <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={e => setKalemForm(f => ({ ...f, fis: e.target.files[0] }))}
                  style={{ width: '100%', padding: '8px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
              <button onClick={() => setKalemModalAcik(false)} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1.5px solid #E5E7EB', background: '#fff', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
              <button onClick={kalemEkle} style={{ flex: 2, padding: '10px', borderRadius: '8px', border: 'none', background: '#4F46E5', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>Ekle</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
